// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import 'bootstrap/dist/css/bootstrap.min.css';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./index.css";
// ===== ПРОСТЫЕ НОВОГОДНИЕ ЭФФЕКТЫ =====

// Проверяем, нужно ли включить эффекты
function shouldEnableEffects() {
  const today = new Date();
  const month = today.getMonth() + 1; // 1-12
  const day = today.getDate();

  // Включаем с 20 декабря по 10 января
  if ((month === 12 && day >= 20) || (month === 1 && day <= 10)) {
    return true;
  }

  // Для тестирования - раскомментируйте:
  // return true;

  return false;
}

// Создание снежинки
function createSnowflake() {
  const snowflake = document.createElement("div");
  snowflake.className = "snowflake";
  snowflake.innerHTML = "❄";

  // Позиция
  snowflake.style.left = `${Math.random() * 100}vw`;

  // Размер
  const size = Math.random() * 20 + 15;
  snowflake.style.fontSize = `${size}px`;

  // Скорость
  const duration = Math.random() * 15 + 10;
  snowflake.style.animationDuration = `${duration}s`;

  // Задержка
  snowflake.style.animationDelay = `${Math.random() * 2}s`;

  // Ветер
  const wind = Math.random() * 40 - 20;
  snowflake.style.setProperty("--wind", `${wind}px`);

  // Прозрачность
  snowflake.style.opacity = Math.random() * 0.7 + 0.3;

  document.body.appendChild(snowflake);

  // Удаление после анимации
  setTimeout(() => {
    if (snowflake.parentNode) {
      snowflake.remove();
    }
  }, duration * 1000);
}

// Создание ёлочного шара (всего 3-4 штуки)
// function createOrnament() {
//   const colors = ["#ff4444", "#44ff44", "#4444ff", "#ffff44", "#ff44ff"];
//   const ornament = document.createElement("div");
//   ornament.className = "christmas-ornament";

//   // Случайный цвет
//   ornament.style.backgroundColor =
//     colors[Math.floor(Math.random() * colors.length)];

//   // Позиция - только по бокам
//   const isLeft = Math.random() > 0.5;
//   ornament.style.left = isLeft ? "20px" : "calc(100vw - 50px)";
//   ornament.style.top = `${Math.random() * 80 + 10}vh`;

//   // Размер
//   const size = Math.random() * 30 + 20;
//   ornament.style.width = `${size}px`;
//   ornament.style.height = `${size}px`;

//   // Анимация
//   const floatDuration = Math.random() * 20 + 15;
//   ornament.style.animationDuration = `${floatDuration}s`;

//   document.body.appendChild(ornament);

//   // Шары не удаляем, они плавают постоянно
// }

// Запуск простых эффектов
function startSimpleEffects() {
  if (!shouldEnableEffects()) {
    return;
  }

  console.log("❄️ Включаем снежинки и шары");

  // Создаём несколько шаров (2-4 штуки)
  const ornamentCount = Math.floor(Math.random() * 2) + 2;
  // for (let i = 0; i < ornamentCount; i++) {
  //   setTimeout(() => createOrnament(), i * 1000);
  // }

  // Запускаем снегопад
  const snowInterval = setInterval(createSnowflake, 300);

  // Возвращаем функцию очистки
  return () => {
    clearInterval(snowInterval);
    document
      .querySelectorAll(".snowflake, .christmas-ornament")
      .forEach((el) => {
        if (el.parentNode) el.remove();
      });
  };
}

// ===== ОСНОВНОЙ КОД REACT =====
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Запускаем эффекты после рендеринга
setTimeout(() => {
  const cleanup = startSimpleEffects();

  // Очистка при hot reload
  if (module.hot && cleanup) {
    module.hot.dispose(() => {
      cleanup();
    });
  }
}, 100);

reportWebVitals();
